import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Crystal_Wedding_Logo_Primary_v2.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 content-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Heartful Logo",
    class: "flex h-40 w-64 mx-auto"
  })
], -1)
const _hoisted_2 = { class: "font-bold text-xl w-full mb-4 text-center" }
const _hoisted_3 = { class: "space-y-4" }
const _hoisted_4 = { class: "text-justify font-light whitespace-pre-line" }
const _hoisted_5 = { class: "text-justify font-light whitespace-pre-line" }
const _hoisted_6 = { class: "w-full flex justify-center mt-30" }

import {
		useI18n
	} from 'vue-i18n'

	// Router
	import {
		useRouter
	} from 'vue-router'

	
	const __default__ = { name: 'SongSubmit' } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


	// Language
	const {t} = useI18n()
	const router = useRouter()


return (_ctx: any,_cache: any) => {
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('confirmationModal.success')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('confirmationModal.message')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('confirmationModal.cutoffDateMessage')), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_tw_button, {
        class: "btn-brand w-1/2",
        onClick: _cache[0] || (_cache[0] = () => _unref(router).push({name: 'Login'}))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('confirmationModal.returnToLogin')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})